export type RealTimeTheme = 'light' | 'dark';

export const DEFAULT_REAL_TIME_THEME: RealTimeTheme = 'dark';

export const isRealTimeTheme = (value: unknown): value is RealTimeTheme =>
  value === 'light' || value === 'dark';

export const normalizeRealTimeTheme = (value: unknown): RealTimeTheme =>
  isRealTimeTheme(value) ? value : DEFAULT_REAL_TIME_THEME;

export const isDarkRealTimeTheme = (theme: RealTimeTheme) => theme === 'dark';

export const getRealTimeThemeClassName = (theme: RealTimeTheme) =>
  isDarkRealTimeTheme(theme) ? 'dark' : '';
